import React from 'react';
import c from 'classnames';
import s from './Stack.scss';
const Stack = ({ children, gap, className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        style: {
            gap
        }
    }, children);
};
Stack.displayName = 'Stack';
export default Stack;

//# sourceMappingURL=Stack.js.map